@if (avoinna) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" [attr.aria-label]="'tositteet.haku.modal-otsikko' | translate | async">
      <app-icon-button (click)="sulje()" actionId="Tositehaku: sulje haku" additionalClass="search-close" matIcon="close" [ariaLabel]="'tositteet.haku.sulje' | translate | async"></app-icon-button>

      <div class="search-content">
        <div class="search-field">
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'tositteet.haku.hakukentan-placeholder' | translate | async }}</mat-label>
            <input type="text" matInput #hakukentta [formField]="lomake.hakuteksti" />
          </mat-form-field>
        </div>

        <div class="filters">
          <div class="dropdown-wrap">
            <app-button (click)="vaihdaPaneeli('aikavali')" actionId="Tositehaku: avaa aikavälisuodatin" additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': aikavali !== 'kaikki' }">
              @if (aikavali === 'kaikki') {
                <span>{{ 'tositteet.haku.rajaa-aikavalia' | translate | async }}</span>
              } @else if (aikavali === 'mukautettu') {
                <span>{{ 'tositteet.haku.aikavali' | translate | async }} · {{ aikavalinTeksti() }}</span>
              } @else {
                <span>{{ 'tositteet.haku.aikavali' | translate | async }} · {{ 'tositteet.haku.aikavali-' + aikavali | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'aikavali') {
              <div class="dropdown aikavali-dropdown">
                @for (preset of aikavaliPresetit; track preset) {
                  <app-button (click)="valitseAikavaliPreset(preset)" actionId="Tositehaku: valitse aikaväli" [actionContext]="[preset]" additionalClass="dropdown-item aikavali-preset" [dynamicClass]="{ 'aikavali-valittu': aikavali === preset }">
                    <span>{{ 'tositteet.haku.aikavali-' + preset | translate | async }}</span>
                    @if (aikavali === preset) {
                      <mat-icon class="aikavali-check">check</mat-icon>
                    }
                  </app-button>
                }

                <div class="dropdown-divider"></div>
                <div class="mukautettu-otsikko">{{ 'tositteet.haku.mukautettu-vali' | translate | async }}</div>

                <div class="date-fields">
                  <mat-form-field class="date-field">
                    <mat-label>{{ 'tositteet.haku.alkaen' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="alkuPicker" [formField]="lomake.alkuPvm" />
                    <mat-datepicker-toggle matSuffix [for]="alkuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #alkuPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field class="date-field">
                    <mat-label>{{ 'tositteet.haku.paattyen' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="loppuPicker" [formField]="lomake.loppuPvm" />
                    <mat-datepicker-toggle matSuffix [for]="loppuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #loppuPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="dropdown-actions">
                  <app-button (click)="valitseAikavali()" actionId="Tositehaku: käytä mukautettua aikaväliä" additionalClass="dropdown-action dropdown-action-primary" [disabled]="!lomake.alkuPvm().value() && !lomake.loppuPvm().value()">
                    {{ 'tositteet.haku.kayta-mukautettua-valia' | translate | async }}
                  </app-button>
                </div>
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <app-button (click)="vaihdaPaneeli('tositelaji')" actionId="Tositehaku: avaa tositelajisuodatin" additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': tositelaji !== oletusTositelaji }">
              <span>{{ 'tositteet.haku.suodatin-tositelaji' | translate | async }} · {{ 'tositteet.haku.tositelaji-' + tositelaji | translate | async }}</span>
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'tositelaji') {
              <div class="dropdown">
                <mat-radio-group class="dropdown-radio-group" [value]="tositelaji" (change)="vaihdaTositelaji($event.value)">
                  <mat-radio-button class="dropdown-item" value="tositteet">{{ 'tositteet.haku.tositelaji-tositteet' | translate | async }}</mat-radio-button>
                  <mat-radio-button class="dropdown-item" value="ostolaskut">{{ 'tositteet.haku.tositelaji-ostolaskut' | translate | async }}</mat-radio-button>
                  <mat-radio-button class="dropdown-item" value="molemmat">{{ 'tositteet.haku.tositelaji-molemmat' | translate | async }}</mat-radio-button>
                </mat-radio-group>
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <app-button (click)="vaihdaPaneeli('toimittaja')" actionId="Tositehaku: avaa toimittajasuodatin" additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutToimittajat.size > 0 }">
              @if (valitutToimittajat.size > 0) {
                <span>{{ 'tositteet.haku.suodatin-toimittaja' | translate | async }} · {{ valitutToimittajat.size }}</span>
              } @else {
                <span>{{ 'tositteet.haku.suodatin-toimittaja' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'toimittaja') {
              <div class="dropdown">
                @for (t of kaikkiToimittajat(); track t.avain) {
                  <mat-checkbox class="dropdown-item" [checked]="onkoToimittajaValittu(t.avain)" (change)="vaihdaToimittaja(t.avain)">{{ t.nimi }}</mat-checkbox>
                }
                @if (valitutToimittajat.size > 0) {
                  <app-button (click)="tyhjennaToimittajat()" actionId="Tositehaku: tyhjennä toimittajavalinnat" additionalClass="dropdown-clear">
                    {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                  </app-button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <app-button (click)="vaihdaPaneeli('maksutapa')" actionId="Tositehaku: avaa maksutapasuodatin" additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutMaksutavat.size > 0 }">
              @if (valitutMaksutavat.size > 0) {
                <span>{{ 'tositteet.haku.suodatin-maksutapa' | translate | async }} · {{ valitutMaksutavat.size }}</span>
              } @else {
                <span>{{ 'tositteet.haku.suodatin-maksutapa' | translate | async }}</span>
              }
              <mat-icon class="filter-caret">expand_more</mat-icon>
            </app-button>

            @if (avoinPaneeli() === 'maksutapa') {
              <div class="dropdown">
                @if (kaikkiMaksutavat().length === 0) {
                  <div class="dropdown-empty">{{ 'tositteet.haku.ei-maksutapoja' | translate | async }}</div>
                } @else {
                  @for (m of kaikkiMaksutavat(); track m.tunniste) {
                    <mat-checkbox class="dropdown-item" [checked]="onkoMaksutapaValittu(m.tunniste)" (change)="vaihdaMaksutapa(m.tunniste)">{{ m.nimi }}</mat-checkbox>
                  }
                  @if (valitutMaksutavat.size > 0) {
                    <app-button (click)="tyhjennaMaksutavat()" actionId="Tositehaku: tyhjennä maksutapavalinnat" additionalClass="dropdown-clear">
                      {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                    </app-button>
                  }
                }
              </div>
            }
          </div>

          @if (naytaProjektitSuodatin()) {
            <div class="dropdown-wrap">
              <app-button (click)="vaihdaPaneeli('projekti')" actionId="Tositehaku: avaa projektisuodatin" additionalClass="filter-btn" [dynamicClass]="{ 'filter-btn-active': valitutProjektit.size > 0 }">
                @if (valitutProjektit.size > 0) {
                  <span>{{ 'tositteet.haku.suodatin-projekti' | translate | async }} · {{ valitutProjektit.size }}</span>
                } @else {
                  <span>{{ 'tositteet.haku.suodatin-projekti' | translate | async }}</span>
                }
                <mat-icon class="filter-caret">expand_more</mat-icon>
              </app-button>

              @if (avoinPaneeli() === 'projekti') {
                <div class="dropdown">
                  @for (p of kaikkiProjektit(); track p.avain) {
                    <mat-checkbox class="dropdown-item" [checked]="onkoProjektiValittu(p.avain)" (change)="vaihdaProjekti(p.avain)">
                      <span [class]="'a' + p.avain + ' kr-projekti-dot projekti-pallo'"></span>
                      <span>{{ p.nimi }}</span>
                    </mat-checkbox>
                  }
                  @if (valitutProjektit.size > 0) {
                    <app-button (click)="tyhjennaProjektit()" actionId="Tositehaku: tyhjennä projektivalinnat" additionalClass="dropdown-clear">
                      {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                    </app-button>
                  }
                </div>
              }
            </div>
          }
        </div>

        @if (aikavali !== 'kaikki' || valitutMaksutavat.size > 0 || valitutProjektit.size > 0 || valitutToimittajat.size > 0) {
          <div class="chips">
            @if (aikavali !== 'kaikki') {
              <span class="filter-chip">
                {{ 'tositteet.haku.aikavali' | translate | async }} ·
                @if (aikavali === 'mukautettu') {
                  {{ aikavalinTeksti() }}
                } @else {
                  {{ 'tositteet.haku.aikavali-' + aikavali | translate | async }}
                }
                <app-icon-button (click)="poistaAikavali()" actionId="Tositehaku: poista aikavälisuodatin" additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'tositteet.haku.poista-suodatin' | translate | async"></app-icon-button>
              </span>
            }
            @for (item of valitutToimittajatLista; track item.avain) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-toimittaja-prefix' | translate | async }} · {{ item.nimi }}
                <app-icon-button (click)="poistaToimittajaValinta(item.avain)" actionId="Tositehaku: poista toimittajasuodatin" additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'tositteet.haku.poista-suodatin' | translate | async"></app-icon-button>
              </span>
            }
            @for (item of valitutMaksutavatLista; track item.tunniste) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-maksutapa-prefix' | translate | async }} · {{ item.nimi }}
                <app-icon-button (click)="poistaMaksutapaValinta(item.tunniste)" actionId="Tositehaku: poista maksutapasuodatin" additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'tositteet.haku.poista-suodatin' | translate | async"></app-icon-button>
              </span>
            }
            @for (item of valitutProjektitLista; track item.avain) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-projekti-prefix' | translate | async }} · {{ item.nimi }}
                <app-icon-button (click)="poistaProjektiValinta(item.avain)" actionId="Tositehaku: poista projektisuodatin" additionalClass="chip-poisto" matIcon="close" [ariaLabel]="'tositteet.haku.poista-suodatin' | translate | async"></app-icon-button>
              </span>
            }
          </div>
        }

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'tositteet.haku.haetaan' | translate | async }}</div>
          } @else if (!onkoHakuehtoja) {
            <div class="hint">{{ 'tositteet.haku.ohje-alkutila' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            <div class="hint">{{ 'tositteet.haku.ei-tuloksia' | translate | async }}</div>
          } @else {
            <div class="list" [class.list-with-projects]="naytaProjektitSuodatin()">
              <div class="list-head">
                <div class="list-th">
                  <span>{{ 'tositteet.paivamaara' | translate | async }}</span>
                </div>
                <div class="list-th">
                  <span>{{ 'tositteet.toimittaja' | translate | async }}</span>
                </div>
                @if (naytaProjektitSuodatin()) {
                  <div class="list-th">
                    <span>{{ 'tositteet.projekti' | translate | async }}</span>
                  </div>
                }
                <div class="list-th">{{ 'tositteet.lisatiedot' | translate | async }}</div>
                <div class="list-th">
                  <span>{{ 'tositteet.maksutapa' | translate | async }}</span>
                </div>
                <div class="list-th list-th-right">
                  <span>{{ 'tositteet.summa' | translate | async }}</span>
                </div>
              </div>

              @for (rivi of tulokset(); track rivi.avain) {
                <div class="list-row-wrapper" role="button" tabindex="0" (click)="avaaTosite(rivi.avain)" (keydown.enter)="avaaTosite(rivi.avain)" (keydown.space)="$event.preventDefault(); avaaTosite(rivi.avain)">
                  <div class="list-row">
                    <div class="list-date">{{ rivi.paivamaara | lnumberpvm | async }}</div>
                    <div class="list-supplier" [class.list-supplier-missing]="!rivi.toimittajanNimi">
                      {{ rivi.toimittajanNimi || ('tositteet.ei-toimittajaa' | translate | async) }}
                    </div>
                    @if (naytaProjektitSuodatin()) {
                      <div class="list-project">
                        @if (projektitMap().get(rivi.projektiAvain); as p) {
                          <span [class]="'a' + p.avain + ' kr-projekti-dot projekti-pallo'"></span>
                          <span class="list-project-nimi">{{ p.nimi }}</span>
                        }
                      </div>
                    }
                    <div class="list-notes">{{ rivi.lisatiedot }}</div>
                    <div class="list-pm">{{ rivi.maksutapaNimi }}</div>
                    <div class="list-amount">{{ rivi.summa | lmoney: 'EUR' | async }}</div>
                  </div>
                </div>
              }
            </div>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu" [pageSize]="sivunKoko" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
